<template>
  <a-modal
    :visible="visible"
    :width="720"
    :mask-closable="false"
    :footer="null"
    :title="title"
    @cancel="close"
  >
    <a-alert
      v-if="record"
      :message="`销售：${record.salesName}（推广短码 ${record.salesCode}）`"
      type="info"
      show-icon
      style="margin-bottom: 16px"
    />

    <a-tabs v-model="activeApp" type="card">
      <a-tab-pane v-for="item in appList" :key="item.appIdent" :tab="item.appName">
        <div class="qr-pane">
          <div class="qr-box">
            <img v-if="qrUrlMap[activeApp]" :src="qrUrlMap[activeApp]" :alt="item.appName + '二维码'" class="qr-img"/>
            <a-empty v-else description="二维码加载中..."/>
          </div>
          <div class="qr-meta">
            <div class="qr-meta__label">二维码内容（扫码跳转）</div>
            <div class="qr-meta__url" :title="contentMap[activeApp]">
              <a-input :value="contentMap[activeApp]" readonly :rows="2" type="textarea" class="qr-meta__textarea"/>
              <a-button style="margin-top: 8px" @click="copyText(contentMap[activeApp], '链接已复制')">
                <a-icon type="copy"/>复制链接
              </a-button>
            </div>
            <div class="qr-actions">
              <a-button type="primary" :loading="downloading === activeApp" @click="downloadQr(activeApp)">
                <a-icon type="download"/>下载 PNG
              </a-button>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import { downloadPromotionQrCode } from '@/api/promotion/sales'

const QR_SIZE = 600

export default {
  name: 'PromotionQrCodeModal',
  data() {
    return {
      visible: false,
      record: null,
      activeApp: 'guzhu',
      downloading: '',
      // 缓存每个 app 的 blobUrl + 内容文本
      blobUrlMap: { guzhu: '', shifu: '' },
      contentMap: { guzhu: '', shifu: '' },
      // 用于 <img> 渲染（直接给 blobUrl 或 base64）；先放空字符串
      qrUrlMap: { guzhu: '', shifu: '' },
      appList: [
        { appIdent: 'guzhu', appName: '雇主端' },
        { appIdent: 'shifu', appName: '师傅端' }
      ]
    }
  },
  computed: {
    title() {
      return this.record ? `下载二维码 - ${this.record.salesName}` : '下载二维码'
    }
  },
  methods: {
    open(record) {
      this.record = record
      this.visible = true
      this.activeApp = 'guzhu'
      this.appList.forEach(item => {
        this.blobUrlMap[item.appIdent] = ''
        this.qrUrlMap[item.appIdent] = ''
      })
      // 触发两端二维码请求
      this.appList.forEach(item => this.loadQrCode(item.appIdent))
    },
    close() {
      // 释放 blob
      Object.keys(this.blobUrlMap).forEach(k => {
        if (this.blobUrlMap[k]) {
          URL.revokeObjectURL(this.blobUrlMap[k])
        }
      })
      this.visible = false
      this.record = null
    },
    loadQrCode(appIdent) {
      if (!this.record || !this.record.salesCode) return
      downloadPromotionQrCode({
        salesCode: this.record.salesCode,
        appIdent: appIdent,
        size: QR_SIZE
      }).then(blob => {
        // 验证是否真的返回了图片
        if (!blob || (blob.size && blob.size < 200)) {
          this.$message.error('二维码生成失败：返回内容异常')
          return
        }
        const url = URL.createObjectURL(blob)
        if (this.blobUrlMap[appIdent]) {
          URL.revokeObjectURL(this.blobUrlMap[appIdent])
        }
        this.blobUrlMap[appIdent] = url
        this.qrUrlMap[appIdent] = url
        // 读 QR 内容文本（用 detail 接口的 qrContent 字段）
        this.contentMap[appIdent] = appIdent === 'guzhu'
          ? (this.record.qrContentGuzhu || '')
          : (this.record.qrContentShifu || '')
        // 若后端在 detail 中没返回内容文本（缓存中没有），降级从二维码显示链接里无法拿
        // 正常情况下 record 是从列表/详情传过来的，含 qrContentGuzhu / qrContentShifu
      }).catch(err => {
        console.error('下载二维码失败', err)
        this.$message.error('二维码生成失败')
      })
    },
    downloadQr(appIdent) {
      if (!this.blobUrlMap[appIdent]) {
        this.$message.error('二维码尚未生成完成，请稍后重试')
        return
      }
      this.downloading = appIdent
      const a = document.createElement('a')
      a.href = this.blobUrlMap[appIdent]
      a.download = `推广二维码-${this.record.salesName}-${appIdent === 'guzhu' ? '雇主端' : '师傅端'}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      this.$message.success('已下载')
      setTimeout(() => { this.downloading = '' }, 500)
    },
    copyText(text, msg) {
      if (!text) {
        this.$message.warning('链接为空')
        return
      }
      this.$copyText(text).then(() => {
        this.$message.success(msg)
      }).catch(() => {
        this.$warning({ title: '请手动复制', content: text })
      })
    }
  }
}
</script>

<style scoped>
.qr-pane {
  display: flex;
  gap: 24px;
  padding: 16px 4px 4px;
}
.qr-box {
  flex: 0 0 320px;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}
.qr-img {
  max-width: 300px;
  max-height: 300px;
}
.qr-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.qr-meta__label {
  font-size: 12px;
  color: #999;
}
.qr-meta__url {
  font-size: 12px;
  color: #666;
  word-break: break-all;
  line-height: 1.5;
}
.qr-meta__textarea {
  resize: none;
  font-family: SFMono-Regular, Consolas, monospace;
  font-size: 12px;
}
.qr-actions {
  margin-top: auto;
}
</style>
